// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollWrapper_wrapper__DLvlC"};